import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-salfa-info-dialog-wrapper',
  templateUrl: './salfa-info-dialog-wrapper.component.html',
  styleUrls: ['./salfa-info-dialog-wrapper.component.scss']
})
export class SalfaInfoDialogWrapperComponent {
    readonly DIALOG_KEYS = {
        REPORTE_CONSOLIDADO: 'REPORTE_CONSOLIDADO',
        REGCHEQ: 'REGCHEQ',
        DEUDA_TAG: 'DEUDA_TAG',
    } as const;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
